import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { FormattedMessage } from 'react-intl';

import Modal from '../../components/modal';
import messages from '../../text/messages';
import WizardButtons from '../../components/wizard/navigator/buttons';
import { TextField, TextAreaField } from '../../components/fields';
import { required } from '../../utilities/validation';
import { ConfirmationDialog } from '../../components/dialogs';
import { dateToFloatingString } from '../../utilities/dateTime';

class AddProject extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            confirmationModal: false
        };

        this.handleModal = this.handleModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.closeConfirmationModal = this.closeConfirmationModal.bind(this);
        this.openConfirmationModal = this.openConfirmationModal.bind(this);
        this.getTitle = this.getTitle.bind(this);
        this.save = this.save.bind(this);
        this.remove = this.remove.bind(this);
    }

    handleModal() {
        this.setState({ modal: true });
    }

    closeModal() {
        this.setState({ modal: false, confirmationModal: false });
    }

    save(values) {
        const { onSubmit, initialValues, reset } = this.props;

        onSubmit({
            ...initialValues,
            ...values,
            start_date: values.start_date && dateToFloatingString(values.start_date, 'YYYY-MM-DD'),
            end_date: values.end_date && dateToFloatingString(values.end_date, 'YYYY-MM-DD')
        });

        reset();
        this.closeModal();
    }

    remove() {
        const { onRemove, initialValues } = this.props;
        onRemove(initialValues.id);
        this.closeModal();
    }

    getTitle() {
        const { initialValues } = this.props;
        return initialValues ? messages.editProjectTitle : messages.addProjectTitle;
    }

    closeConfirmationModal() {
        this.setState({ confirmationModal: false });
    }

    openConfirmationModal() {
        this.setState({ confirmationModal: true });
    }

    render() {
        const { modal, confirmationModal } = this.state;
        const { handleSubmit, submitting, initialValues } = this.props;

        return (
            <div>
                <span onClick={this.handleModal} className={`button ${initialValues ? 'edit' : ''}`}>
                    <FormattedMessage {...(initialValues ? messages.edit : messages.addProject)} />
                </span>

                <Modal open={modal} onClose={this.closeModal} size="col-sm-6 col-sm-offset-3 col-xs-12" title={<FormattedMessage {...this.getTitle()} />}>
                    <div>
                        <div className="close-modal" onClick={this.closeModal}>
                            <i className="material-icons">clear</i>
                        </div>

                        <div className="row">
                            <div className="col-xs-12">
                                <form onSubmit={handleSubmit(this.save)}>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <Field name="name" validate={[required]} component={TextField} placeholder={messages.name} />
                                        </div>
                                        <div className="col-xs-12">
                                            <Field name={'description'} component={TextAreaField} placeholder={messages.detailedDescription} />
                                        </div>
                                    </div>

                                    <ConfirmationDialog
                                        modal={{ open: confirmationModal }}
                                        onSubmit={() => null}
                                        onClose={this.closeConfirmationModal}
                                        message={<FormattedMessage {...messages.removeDeliverableConfirmation} />}
                                        save={{ message: <FormattedMessage {...messages.confirm} />, action: this.remove }}
                                    />

                                    <WizardButtons
                                        disabled={submitting}
                                        // reject={{
                                        //     show: !!initialValues,
                                        //     action: this.openConfirmationModal,
                                        //     message: <FormattedMessage {...messages.remove} />
                                        // }}
                                        back={{ action: this.closeModal, message: <FormattedMessage {...messages.cancel} /> }}
                                        submit={{ message: <FormattedMessage {...messages.confirm} /> }}
                                    />
                                </form>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

AddProject = reduxForm({
    destroyOnUnmount: false,
    enableReinitialize: true,
    forceUnregisterOnUnmount: true
})(AddProject);

const mapStateToProps = (state, props) => ({
    form: `project-${props.initialValues ? props.initialValues.id : 'new'}`,
    initialValues: props.initialValues
        ? {
              ...props.initialValues,
              ...{
                  start_date: props.initialValues.start_date ? moment(props.initialValues.start_date) : undefined,
                  end_date: props.initialValues.end_date ? moment(props.initialValues.end_date) : undefined
              }
          }
        : undefined
});

export default connect(mapStateToProps, null)(AddProject);



// WEBPACK FOOTER //
// ./src/pages/projects/addProject.jsx